<template>
  <div id="listener_carrello_insit">
    <!-- Prompt per inserire WO in un carrello vuoto -->
    <v-card v-if="items_carrello.length == 0">
      <v-toolbar class="white--text" color="indigo" dense>
        <v-row>
          <v-col align="left" cols="4">
            <v-toolbar-title>
              Work Order -
              <b>{{
                cod_turno_sel != null && cod_turno_sel != ""
                  ? cod_turno_sel
                  : "N/D"
              }}</b>
            </v-toolbar-title>
          </v-col>
          <v-col cols="4"></v-col>
          <v-col align="right" cols="4">
            <!-- Bottone per tornare indietro -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="gotoDashboard" v-bind="attrs" v-on="on" small>
                  <v-icon color="error">mdi-keyboard-backspace</v-icon>
                </v-btn>
              </template>
              <span>Vai alla Dashboard</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-toolbar>

      <v-card-text class="mt-5" style="font-size: 20px; line-height: 20px">
        Ciao {{ nome_utente }}, la lista dei Work Order è vuota: ne vuoi
        aggiungere uno?
      </v-card-text>
      <v-divider></v-divider>
      <!-- Bottone per aggiungere una commessa singola -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5 my-2"
            @click="clickAggiungi"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Work Order</span>
      </v-tooltip>
    </v-card>

    <!-- Componenti per i WO presenti -->
    <v-card v-else>
      <v-toolbar rounded class="white--text" color="indigo" dense>
        <v-row>
          <v-col align="left" cols="4">
            <v-toolbar-title>
              Work Order - turno:
              <b>{{
                cod_turno_sel != null && cod_turno_sel != ""
                  ? cod_turno_sel
                  : "N/D"
              }}</b>
            </v-toolbar-title>
          </v-col>
          <v-col align="center" cols="4">
            <!-- Bottone per aggiungere le commesse -->
            <span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="clickAggiungi" small v-bind="attrs" v-on="on">
                    <v-icon color="primary">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Aggiungi Work Order</span>
              </v-tooltip>
            </span>
          </v-col>

          <v-col align="right" cols="4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="gotoDashboard" v-bind="attrs" v-on="on" small>
                  <v-icon color="error">mdi-keyboard-backspace</v-icon>
                </v-btn>
              </template>
              <span>Vai alla Dashboard</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-card-text>
        <v-container fluid :key="i" v-for="(workorder, i) in items_carrello">
          <!-- Ingresso della dashboard vera e propria -->
          <ProduzioneLayoutRow
            @click_chiusura_massiva_fasi="handleClickChiusuraMassivaFasi"
            @click_registra_art_res="handleClickRegistraArtRes"
            @click_registra_peso="handleClickRegistraPeso"
            @click_riapertura_master="handleClickRiaperturaMaster"
            @click_allegati_fase="handleClickAllegatiFase"
            @click_allegati_commessa="handleClickAllegatiCommessa"
            @click_applicazione_loghi="handleClickApplicazioneLoghi"
            @click_avanza_confezioni="handleClickAvanzaConfezioni"
            @click_avanza_contenitore="handleClickAvanzaContenitore"
            @click_avanza_contenitore_sf="handleClickAvanzaContenitoreSF"
            @click_check="transmitClickCheck"
            @click_campionatura="handleClickCampionatura"
            @click_chiusura_fase="handleClickChiusuraFase"
            @click_controllo_mp="handleClickControlloMP"
            @click_controllo_qualita="handleClickControlloQualita"
            @click_gestione_pulsanti="handleClickGestionePulsanti"
            @click_history="handleClickHistory"
            @click_lavoro_squadra="handleClickLavoroSquadra"
            @click_nascondi="handleClickNascondi"
            @click_manutenzione="handleClickManutenzione"
            @click_note_commessa="handleClickNoteCommessa"
            @click_note_fase="handleClickNoteFase"
            @click_note_fase_precedente="handleClickNoteFasePrecedente"
            @click_prelievi="handleClickPrelievi"
            @click_questionario_qualita="handleClickQuestionarioQualita"
            @click_registra_fermi="handleClickRegistraFermi"
            @click_registra_imballi="handleClickRegistraImballi"
            @click_registra_pezzi="handleClickRegistraPezzi"
            @click_registra_pezzi_alternativi="
              handleClickRegistraPezziAlternativi
            "
            @click_registra_pezzi_seriali="handleClickRegistraPezziSeriali"
            @click_registra_scarti="handleClickRegistraScarti"
            @click_registra_cont_alternativi="
              handleClickRegistraContAlternativi
            "
            @click_visualizza_allegto_controllo="
              handleClickVisualizzaAllegatoControllo
            "
            @click_ristampa_seriale="handleClickRistampaSeriale"
            @click_visualizza_disegno="handleClickVisualizzaDisegno"
            @click_scheda_packaging="handleClickSchedaPackaging"
            @click_scheda_richieste="handleClickSchedaRichieste"
            @click_segnalazione="handleClickSegnalazione"
            @click_start="handleClickStart"
            @click_stop="handleClickStop"
            @click_subentro="handleClickSubentro"
            @column_is_mounted="handleColumnIsMounted"
            :gestione_team_enabled="gestione_team_enabled"
            :handleClickCheck="handleClickCheck"
            :key="j"
            :riga="riga"
            v-for="(riga, j) in colonne[0].righe.filter((r) => r.validita == 1)"
            :workorder="workorder"
          />
          <div
            style="
              background-color: #000000;
              display: inline-block;
              height: 1px;
              margin-bottom: 20px;
              margin-top: 40px;
              width: 70%;
            "
            v-if="i < items_carrello.length - 1"
          ></div>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog_turni_visible" width="unset" persistent>
      <DichiarazioneTurni
        @click_chiudi="dialog_turni_visible = false"
        @click_save="clickSaveTurno"
      />
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import DichiarazioneTurni from "@/components/PRODUCTION/ProduzioneInsit/DichiarazioneTurno.vue";
import ProduzioneColumnObject from "@/classes/ProduzioneColumnObject.js";
import ProduzioneDetailObject from "@/classes/ProduzioneDetailObject.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",
  components: {
    DichiarazioneTurni,
    ProduzioneLayoutRow: () =>
      import(
        "@/components/PRODUCTION/ProduzioneLayout/ProduzioneLayoutRow.vue"
      ),
    SnackbarQV,
  },
  props: {
    back_as_landing_page: {
      type: Boolean,
      default: true,
    },
    items_carrello: { type: Array, default: () => [] },
    rotta_back: {
      type: String,
      default: "/home/production",
    },
    handleClickCheck: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      cod_turno_sel: "",
      gestione_team_enabled: 0,
      isAdmin: false,
      nome_utente: localStorage.getItem("nominativo"),

      // Modal
      dialog_turni_visible: false,

      // Array
      colonne: [new ProduzioneColumnObject()],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    clickAggiungi() {
      this.$emit("click_aggiungi");
    },
    clickSaveTurno(arg_cod) {
      this.$refs.SnackbarQV.print(
        "success",
        `Turno ${arg_cod} selezionato con successo`
      );
      this.cod_turno_sel = arg_cod;
      this.dialog_turni_visible = false;
    },
    formatObjects(arr) {
      // Pero ogni colonna di questo array...
      for (let c = 0; c < arr.length; c++) {
        // ... Se ha degli oggetti...
        if (arr[c].oggetto) {
          // ... Controlla la struttura di ogni oggetto.
          for (let o = 0; o < arr[c].oggetto.length; o++) {
            this.$set(
              arr[c].oggetto,
              o,
              new ProduzioneDetailObject(arr[c].oggetto[o])
            );
          }
        } else {
          /* Se non ha un oggetto, gli metto l'array
           * per comodità e uniformità dei dati in FE. */
          arr[c].oggetto = new Array();
        }

        // Se ci sono righe nella colonna...
        if (arr[c].righe) {
          // ... Per ogni riga...
          for (let r = 0; r < arr[c].righe.length; r++) {
            // ... Se la riga contiene colnne...
            if (arr[c].righe[r].colonne) {
              // ... Lancia questa funzione su ogni colonna.
              this.formatObjects(arr[c].righe[r].colonne);
            }
          }
        }
      }
    },
    getDichiaraTurno() {
      const request2 = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getprofiliturni",
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request2).then((res) => {
        if (res.status === 200) {
          for (let i2 = 0; i2 < res.data.result.turni_profili.length; i2++) {
            if (
              parseInt(localStorage.getItem("id_profilo")) ==
              res.data.result.turni_profili[i2].id_profilo
            ) {
              this.showTurnoDialog();
              break;
            }
          }
          this.loading = false;
        }
      });
    },
    getLayoutAssociazioni() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlayoutassociazioni",
          token: localStorage.user_token,
          id_profilo: localStorage.id_profilo,
          modulo: "AVANZAMENTO",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            this.getLayoutStruttura(res.data.result.associazioni[0].id_layout);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getLayoutStruttura(arg) {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlayoutstruttura",
          token: localStorage.user_token,
          id_layout: arg,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            const arr_tmp = [new ProduzioneColumnObject(res.data.result)];

            /* Se il layout è vuoto, di per sé il BE non me lo restituisce con un
             * id_layout e id_layout_tmp. In questo caso avviso che la dashboard è
             * vuota con una snackbar. */
            if (!res.data.result) {
              this.$refs.SnackbarQV.print(
                "orange",
                "La dashboard associata a questo profilo non contiene strutture."
              );
            }

            this.formatObjects(arr_tmp);

            // Registro la struttura del layout.
            this.$set(this.colonne, 0, new ProduzioneColumnObject(arr_tmp[0]));

            // Registro il titolo del layout selezionato.
            this.titolo_layout_sel = arg.titolo;

            // Chiudo il dialog di caricamento.
            this.dialog_caricamento = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getPulsantiCruscotto() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpulsantiheader",
          token: localStorage.user_token,
          tipo_oggetto: "B",
          nome_modulo: "AVANZAMENTO",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            /* Verifico che il pulsante degli avvii multipli sia abilitato,
             * poi lo cancello perché per il cruscotto di avanzamento non avrebbe
             * senso di esistere sulle varie righe. (Il tasto di avvio multiplo
             * dei WO non deve stare nello spazio dei WO ma in una toolbar e deve
             * essere sempre solo un pulsate, per questo lo cancellerò con le
             * istruzioni qui sotto.) Faccio un ragionamento analogo anche per
             * il pulsante di lavoro squadra, che se è visibile deve far scattare
             * una chiamata particolare quando si stoppa il WO. */
            res.data.forEach((b) => {
              if (b.text === "Avvio Multiplo WO") {
                this.$emit("config_avvio_multiplo_wo", b.visible);
              } else if (b.text === "Lavoro Squadra") {
                this.gestione_team_enabled = b.visible;
              }
            });

            /* Se presente, emetto l'id_header_query in modo che il componente
             * padre lo possa passare in prop ai componenti che ne hanno bisogno. */
            res.data.forEach((d) => {
              if (d.query != null) {
                this.$emit("id_header_query", d.id_header);
              }
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getTurnoUtente() {
      // Funzione per recuperare dal BE l'eventuale turno dell'operatore.
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getturnoutente",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (
              res.data &&
              res.data.result &&
              res.data.result.turno &&
              res.data.result.turno[0]
            ) {
              this.cod_turno_sel = res.data.result.turno[0].cod_turno;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    gotoDashboard() {
      if (this.back_as_landing_page === true) {
        this.$router.push(this.rotta_back);
      } else {
        /* Emetto un evento per scatenare nel padre
         * la gestione dell'evento click indietro. */
        this.$emit("click_indietro");
      }
    },
    handleClickChiusuraMassivaFasi(arg) {
      this.$emit("click_chiusura_massiva_fasi", arg);
    },
    handleClickRegistraArtRes(arg) {
      this.$emit("click_registra_art_res", arg);
    },
    handleClickRegistraPeso(arg) {
      this.$emit("click_registra_peso", arg);
    },
    handleClickRiaperturaMaster(arg) {
      this.$emit("click_riapertura_master", arg);
    },
    handleClickAllegatiFase(arg) {
      this.$emit("click_allegati_fase", arg);
    },
    handleClickAllegatiCommessa(arg) {
      this.$emit("click_allegati_commessa", arg);
    },
    handleClickApplicazioneLoghi(arg) {
      this.$emit("click_applicazione_loghi", arg);
    },
    handleClickAvanzaConfezioni(arg) {
      this.$emit("click_avanza_confezioni", arg);
    },
    handleClickAvanzaContenitore(arg) {
      this.$emit("click_avanza_contenitore", arg);
    },
    handleClickAvanzaContenitoreSF(arg) {
      this.$emit("click_avanza_contenitore_sf", arg);
    },
    handleClickCampionatura(arg) {
      this.$emit("click_campionatura", arg);
    },
    handleClickChiusuraFase(arg) {
      this.$emit("click_chiusura_fase", arg);
    },
    handleClickControlloMP(arg) {
      this.$emit("click_controllo_mp", arg);
    },
    handleClickControlloQualita(arg) {
      this.$emit("click_controllo_qualita", arg);
    },
    handleClickGestionePulsanti() {
      this.$emit("click_gestione_pulsanti");
    },
    handleClickHistory(arg) {
      this.$emit("click_history", arg);
    },
    handleClickLavoroSquadra(arg) {
      this.$emit("click_lavoro_squadra", arg);
    },
    handleClickNascondi(arg) {
      this.$emit("click_nascondi", arg);
    },
    handleClickManutenzione(arg) {
      this.$emit("click_manutenzione", arg);
    },
    handleClickNoteCommessa(arg) {
      this.$emit("click_note_commessa", arg);
    },
    handleClickNoteFase(arg) {
      this.$emit("click_note_fase", arg);
    },
    handleClickNoteFasePrecedente(arg) {
      this.$emit("click_note_fase_precedente", arg);
    },
    handleClickPrelievi(arg) {
      this.$emit("click_prelievi", arg);
    },
    handleClickQuestionarioQualita(arg_wo, arg_questionario) {
      this.$emit("click_questionario_qualita", arg_wo, arg_questionario);
    },
    handleClickRegistraFermi(arg) {
      this.$emit("click_registra_fermi", arg);
    },
    handleClickRegistraImballi(arg) {
      this.$emit("click_registra_imballi", arg);
    },
    handleClickRegistraPezzi(arg) {
      this.$emit("click_registra_pezzi", arg);
    },
    handleClickRegistraPezziAlternativi(arg) {
      this.$emit("click_registra_pezzi_alternativi", arg);
    },
    handleClickRegistraPezziSeriali(arg) {
      this.$emit("click_registra_pezzi_seriali", arg);
    },
    handleClickRegistraScarti(arg) {
      this.$emit("click_registra_scarti", arg);
    },
    handleClickRegistraContAlternativi(arg) {
      this.$emit("click_registra_cont_alternativi", arg);
    },
    handleClickRistampaSeriale(arg) {
      this.$emit("click_ristampa_seriale", arg);
    },
    handleClickSegnalazione(arg) {
      this.$emit("click_segnalazione", arg);
    },
    handleClickVisualizzaAllegatoControllo(arg) {
      this.$emit("click_visualizza_allegto_controllo", arg);
    },
    handleClickVisualizzaDisegno(arg) {
      this.$emit("click_visualizza_disegno", arg);
    },
    handleClickSchedaPackaging(arg) {
      this.$emit("click_scheda_packaging", arg);
    },
    handleClickSchedaRichieste(arg) {
      this.$emit("click_scheda_richieste", arg);
    },
    handleClickStart() {
      this.$emit("click_start");
    },
    handleClickStop(commessa, arg_nascondi, arg_dialog) {
      this.$emit("click_stop", commessa, arg_nascondi, arg_dialog);
    },
    handleClickSubentro(arg) {
      this.$emit("click_subentro", arg);
    },
    handleColumnIsMounted(arg) {
      this.$emit("column_is_mounted", arg);
    },
    showTurnoDialog() {
      this.dialog_turni_visible = true;
    },
    transmitClickCheck(wo, cod_btn) {
      this.$emit("click_check", wo, cod_btn);
    },
  },
  created() {},
  mounted() {
    this.NETWORK = this.$store.state.Network;
    this.isAdmin = localStorage.getItem("id_profilo") == 1;
    // Preparo i listener.
    document
      .getElementById("listener_carrello_insit")
      .addEventListener("cambiata_macchina", this.cambiaMacchina);

    document
      .getElementById("listener_carrello_insit")
      .addEventListener("prelievo_registrato", this.aggiornaPrelievi);

    /* Una volta si dichiarava il turno in questo componente, ora si dichiara
     * il turno con un popup che fa parte del sistema delle Notifiche. Il
     * metodo che inizializzava il flusso della vecchia dichiarazione turno
     * è quello commentato qui sotto. */
    //this.getDichiaraTurno();

    this.getLayoutAssociazioni();
    this.getPulsantiCruscotto();
    this.getTurnoUtente();
  },
};
</script>
<style scoped>
@keyframes controtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes rotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.controruota {
  animation: controtazione 1s infinite;
  animation-timing-function: linear;
}
.ruota {
  animation: rotazione 1s infinite;
  animation-timing-function: linear;
}
#listener_carrello_insit {
  font-size: 20px;
  text-align: center;
}
#listener_carrello_insit .button {
  height: 70px;
  width: 70px;
  min-width: 70px;
}
#listener_carrello_insit .evidenziato {
  background-color: pink;
}
#listener_carrello_insit .v-list-item {
  padding: 0;
}
#listener_carrello_insit .v-divider {
  border-color: #3f51b5;
  border-width: 2px;
}
#listener_carrello_insit .label {
  color: #3f51b5;
  margin-bottom: 7px;
}

@media screen and (max-width: 900px) {
  #listener_carrello_insit {
    font-size: 18px;
  }
  #listener_carrello_insit .button {
    height: 65px;
    width: 65px;
    min-width: 65px;
  }
}
@media screen and (max-width: 840px) {
  #listener_carrello_insit {
    font-size: 16px;
  }
  #listener_carrello_insit .button {
    height: 60px;
    width: 60px;
    min-width: 60px;
  }
}
</style>